export default class PricingVariantGroup {
  route = null;

  variants = [];

  dateOptions = [];

  selectedDateUid = null;

  constructor (data) {
    this.route = data.route;
    this.dateOptions = data.dateOptions || [];
    this.selectedDateUid = data.selectedDateUid;
    this.variants = data.variants || [];
  }

  get uid () {
    return this.route.uid;
  }

  get selectedDate () {
    return this.dateOptions.find(opt => opt.name === this.selectedDateUid);
  }

  get selectedVariant () {
    return this.variants.find(opt => opt.uid === this.selectedDateUid);
  }

  get detalization () {
    if (!this.selectedVariant) return {};
    return this.selectedVariant.detalization;
  }

  get computedPrice () {
    return this.detalization.computedPrice;
  }

  get computedPriceCompact () {
    return this.detalization.computedPriceCompact;
  }

  get selectedRaids () {
    return this.selectedVariant.raidsUid;
  }

  get raidNumbers () {
    const numbers = this.variants.flatMap(variant => variant.numbers);
    return [...new Set(numbers)];
  }

  addVariant (item) {
    this.variants.push(item);
    const uid = item.route.path.firstLeg.departure.date.dateUid;
    if (!this.dateOptions.length) this.selectedDateUid = uid;
    const optionWithUid = this.dateOptions.find(opt => opt.name === uid);
    if (!optionWithUid) {
      this.dateOptions.push({
        dateFrom: item.route.path.firstLeg.departure.date,
        dateTo: item.route.path.lastLeg.arrival.date,
        capacity: item.capacity,
        priceInfo: item.priceInfo,
        totalPrice: item.totalPrice,
        name: uid,
        count: 1,
      });
    } else {
      optionWithUid.count += 1;
    }
  }
};
